import {ProductionOrderProgress} from './production-order-progress';

export class OverviewMachineProductionOrder {
  private _name: string;
  private _progress: ProductionOrderProgress;

  public constructor(name: string, progress: ProductionOrderProgress) {
    this._name = name;
    this._progress = progress;
  }

  public get name(): string {
    return this._name;
  }

  public get progress(): ProductionOrderProgress {
    return this._progress;
  }
}
